import React from 'react';
import { cx } from '../../../../../ui/components/cx';
import './CalendarLegend.scss';

export interface CalendarLegendItem {
  label: string;
  /**
   * Swatch colour. Must match the colour the page hands to FullCalendar for that event type,
   * so it comes from data rather than a token.
   */
  color: string;
}

interface CalendarLegendProps {
  items: CalendarLegendItem[];
  /** Accessible name for the list. */
  label?: string;
  /** Keep every item on one line (the parent scrolls horizontally). */
  nowrap?: boolean;
  className?: string;
}

/** Colour key for calendar event types. */
const CalendarLegend: React.FC<CalendarLegendProps> = ({ items, label = 'Legend', nowrap, className }) => (
  <ul className={cx('ds-legend', nowrap && 'ds-legend--nowrap', className)} aria-label={label}>
    {items.map((item) => (
      <li key={item.label} className="ds-legend__item">
        <span
          className="ds-legend__swatch"
          aria-hidden
          // Runtime colour hand-off: the swatch mirrors a FullCalendar event colour.
          style={{ '--ds-legend-swatch': item.color } as React.CSSProperties}
        />
        {item.label}
      </li>
    ))}
  </ul>
);

export default CalendarLegend;
